var $ = require('jquery');
var unavailable = require('../helpers/unavailable');
require('jquery-datepicker');

var Booking = function Booking() {
	var $calendars = $('.wpcf7 .calendar');

	var onSelect = function onSelect(date, $this) {
		date = new Date(date);
		$this.find('input[type="hidden"]').val(date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear());

		$this.find('.selected').text('Selected: ' + date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear());
	}

	if($calendars.length) {
		var $propertyDD = $('.wpcf7 select[name="property"]');

		$calendars.each(function() {
			var $this = $(this);
			$this.find('.trigger').datepicker('option', 'onSelect', function(date) {
				onSelect(date, $this);
				
				if($this.attr('data-type') === 'from') {
					var split = date.split('/').map(function(num) { return parseInt(num); });
					$calendars.filter('[data-type="to"]').find('.trigger').datepicker('option', 'minDate', new Date(split[2], split[0] - 1, split[1]));
				}
			});
		});

		var setUnavailableDates = function setUnavailableDates(propId) {
			$.ajax({
				method: 'POST',
				url: __CONFIG__.ajaxUrl,
				data: {
					id: propId,
					action: 'get_unavailable_dates'
				}
			}).done(function(data) {
				var dates = JSON.parse(data);

				$calendars.each(function() {
					$(this).find('.trigger').datepicker('option', 'beforeShowDay', unavailable.bind(null, dates));
				});
			});
		}

		setUnavailableDates($propertyDD.find('option:selected').attr('data-id'));

		$propertyDD.on('change', function() {
			setUnavailableDates($(this).find('option:selected').attr('data-id'));
		});
	}
}

module.exports = Booking;